'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.registerClickable = registerClickable;
exports.unregisterClickable = unregisterClickable;
exports.createInteractiveObject = createInteractiveObject;

var _Node = require('../widgets/Node');

var _Node2 = _interopRequireDefault(_Node);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var registeredClickables = [];
var fixName = function fixName(name) {
  return name.replace(/^[^a-zA-Z_$]|[^0-9a-zA-Z_$]/g, '_');
};
var createFunction = function createFunction(name) {
  return new Function('return function ' + fixName(name) + '(){}')();
}; // eslint-disable-line

function registerClickable(element) {
  if (!(element instanceof Object)) {
    throw new TypeError('Value of argument "element" violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(element));
  }

  registeredClickables.push(element);
}

function unregisterClickable(element) {
  if (!(element instanceof Object)) {
    throw new TypeError('Value of argument "element" violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(element));
  }

  registeredClickables.splice(registeredClickables.indexOf(element), 1);
}

function createInteractiveObject(element) {
  function _ref3(_id3) {
    if (!(_id3 instanceof Object)) {
      throw new TypeError('Function "createInteractiveObject" return value violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(_id3));
    }

    return _id3;
  }

  if (!(element instanceof _Node2.default)) {
    throw new TypeError('Value of argument "element" violates contract.\n\nExpected:\nNode\n\nGot:\n' + _inspect(element));
  }

  var object = new (createFunction(element.label))();
  Object.defineProperty(object, 'element', {
    enumerable: false,
    configurable: false,
    get: function get() {
      return element;
    }
  });

  return _ref3(object);
}

Object.getOwnPropertyDescriptor = function () {
  var object = arguments.length <= 0 ? undefined : arguments[0];
  var index = registeredClickables.indexOf(object);

  if (index !== -1) {
    registeredClickables[index].element.emit('click');
    unregisterClickable(object);
    return;
  }

  return getOwnPropertyDescriptor.apply(undefined, arguments);
};

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : _typeof(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = Object.keys(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : JSON.stringify(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../lib/utils/interaction.js
// module id = 690
// module chunks = 0